import ReactJson, { OnCopyProps, ReactJsonViewProps } from 'react-json-view';

export type JsonRendererProps = ReactJsonViewProps;

export const JsonRenderer: React.FC<JsonRendererProps> = (props) => {
    const handleCopy = (copy: OnCopyProps) => {
        navigator.clipboard.writeText(JSON.stringify(copy.src, null, 2));
      };
    
    return <ReactJson enableClipboard={ handleCopy } { ...props } />;
};
